import { useState } from "react";
import { useMockMode } from "@/contexts/MockModeContext";
import "./styles.css";

export default function MockToggle() {
  const { isMockMode, toggleMockMode, isLoading } = useMockMode();
  const [isHovered, setIsHovered] = useState(false);

  // Detectar se está rodando no Lovable
  const isLovable =
    window.location.hostname.includes("lovable.app") || window.location.hostname.includes("lovable.dev");

  // Só mostrar em desenvolvimento ou no Lovable
  if (!import.meta.env.DEV && !isLovable) {
    return null;
  }

  return (
    <>
      {/* Indicador de Modo */}
      <div
        className="mock-toggle-container"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <button
          className={`mock-toggle-button ${isMockMode ? "mock-active" : "real-active"} ${isLoading ? "loading" : ""} ${!isHovered ? "hidden-button" : ""}`}
          onClick={toggleMockMode}
          disabled={isLoading}
          title={isMockMode ? "Modo Mock Ativo - Clique para usar API Real" : "Modo Real Ativo - Clique para usar Mock"}
        >
          <div className="mode-indicator">
            <div className="toggle-switch">
              <div className="toggle-slider">
                <span className="toggle-icon">{isMockMode ? "🎭" : "🌐"}</span>
              </div>
            </div>
            {isHovered && (
              <span className="toggle-label">{isLoading ? "Alternando..." : isMockMode ? "MOCK" : "REAL"}</span>
            )}
          </div>
        </button>

        {/* Badge indicador para ambos os modos */}
        {!isHovered && (
          <div className={`mode-indicator-badge ${isMockMode ? "mock-badge" : "real-badge"}`}>
            <span className="badge-dot"></span>
            <span className="badge-text">{isMockMode ? "MOCK" : "REAL"}</span>
          </div>
        )}
      </div>
    </>
  );
}
